import { render, staticRenderFns } from "./DashLitigationList.vue?vue&type=template&id=a94f43d6&scoped=true&"
import script from "./DashLitigationList.vue?vue&type=script&lang=js&"
export * from "./DashLitigationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94f43d6",
  null
  
)

export default component.exports